/* Autenticação */
import Login from "./views/Auth/Login.jsx";
import TrocarSenha from "./views/Auth/TrocarSenha.jsx";
import EsqueceuSenha from "./views/Auth/EsqueceuSenha.jsx";
import TransportadoresCredenciados from "./views/Auth/TransportadoresCredenciados.jsx";

import Inicio from "./views/Home/Inicio/Inicio.jsx";
import DashBoard from "./views/Home/DashBoard.jsx";
import Destinos from "./views/Cadastros/Destinos/Destinos.jsx";
import Documentos from "./views/Cadastros/Documentos/Documentos.jsx";
import Geradores from "./views/Cadastros/Geradores/Geradores.jsx";
import Transportadores from "./views/Cadastros/Transportadores/Transportadores.jsx";
import Prefeituras from "./views/Cadastros/Prefeituras/Prefeituras.jsx";
import Bairros from "./views/Cadastros/Bairros/Bairros.jsx";
import Regionais from "./views/Cadastros/Regionais/Regionais.jsx";
import Emails from "./views/Cadastros/Emails/Emails.jsx";
import ModalidadeColeta from "./views/Cadastros/ModalidadeColeta/ModalidadeColeta.jsx";
import TipoDestino from "./views/Cadastros/TipoDestino/TipoDestino.jsx";
import TiposImplemento from "./views/Cadastros/TiposImplemento/TiposImplemento.jsx";
import TipoNotificacoes from "./views/Cadastros/TipoNotificacoes/TipoNotificacoes.jsx";
import Cnae from "./views/Cadastros/Cnae/Cnae.jsx";
import Residuos from "./views/Cadastros/Residuos/Residuos.jsx";
import Volumetria from "./views/Cadastros/Volumetria/Volumetria.jsx";
import ResiduoVolumetria from "./views/Cadastros/ResiduoVolumetria/ResiduoVolumetria.jsx";
import RamoDeAtividade from "./views/Cadastros/RamoDeAtividade/RamoDeAtividade.jsx";
import Certificados from "./views/Cadastros/Certificados/Certificados.jsx";
import Assinaturas from "./views/Cadastros/Assinaturas/Assinaturas.jsx";
import EscalaFuncionarios from "./views/Cadastros/EscalaFuncionarios/EscalaFuncionarios.jsx";
import Usuarios from "./views/Seguranca/Usuarios/Usuarios.jsx";
import UsuarioExternos from "./views/Seguranca/UsuarioExterno/UsuarioExternos.jsx";
import OrdemDeColeta from "./views/OrdemColeta/Programacao/OrdemColeta";
import RotasColeta from "./views/Cadastros/RotasColeta/RotasColeta.jsx";
import ManutencaoColetas from "./views/OrdemColeta/Manutencao/ManutencaoColetas.jsx";
import EntradaResiduos from "./views/ReceberResiduos/EntradaResiduos.jsx";
import ManutencaoPesagem from "./views/ReceberResiduos/ManutencaoPesagem.jsx";
import SaidaResiduos from "./views/ReceberResiduos/SaidaResiduos.jsx";
import PesquisaMTR from "./views/PesquisaMTR/PesquisaMTR.jsx";
import ColetasRecusadas from "./views/OrdemColeta/ColetasRecusadas/ColetasRecusadas.jsx";
import PesquisaNaoColeta from "./views/PesquisaNaoColeta/PesquisaNaoColeta.jsx";
import CorreioInterno from "./views/CorreioInterno/CorreioInterno.jsx";
import EmissaoCertificados from "./views/EmissaoCertificados/EmissaoCertificados.jsx";
import MensagemInterna from "./views/CorreioInterno/MensagemInterna.jsx";
import CertificadoEmitido from "./views/EmissaoCertificados/CertificadoEmitido.jsx";
import Denuncia from "./views/Denuncia/Denuncia.jsx";
import FichaTransportador from "./views/Cadastros/Transportadores/FichaTransportador.jsx";
import FormularioPGRS from "./views/Cadastros/FormularioPGRS/FormularioPGRS.jsx";

//Relatorios
import RelatorioMTR from "./views/Relatorios/RelatorioMTR.jsx";
import Relatorios from "./views/Relatorios/Relatorios.jsx";
import DetalhadoPorGerador from "./views/Relatorios/DetalhadoPorGerador/DetalhadoPorGerador.jsx";
import DetalhadoPorTransportador from "./views/Relatorios/DetalhadoPorTransportador/DetalhadoPorTransportador.jsx";
import ColetasDetalhado from "./views/Relatorios/ColetasDetalhado/ColetasDetalhado.jsx";
import ColetasResumido from "./views/Relatorios/ColetasResumido/ColetasResumido.jsx";
import DemonstrativoDeResumoDeOperacoes from "./views/Relatorios/DemonstrativoDeResumoDeOperacoes/DemonstrativoDeResumoDeOperacoes.jsx";
import DemonstrativoDeColetasPorGeradores from "./views/Relatorios/DemonstrativoDeColetasPorGerador/DemonstrativoDeColetasPorGerador.jsx";
import ContratosPorTransportador from "./views/Relatorios/ContratosPorTransportador/ContratosPorTransportador.jsx";
import EntradasAvulsas from "./views/Relatorios/EntradasAvulsas/EntradasAvulsas.jsx";
import ColetasPorGerador from "./views/Relatorios/ColetasPorGerador/ColetasPorGerador.jsx";
import ColetasPorTransportador from "./views/Relatorios/ColetasPorTransportador/ColetasPorTransportador.jsx";
import ColetasPorDestinoFinal from "./views/Relatorios/ColetasPorDestinoFinal/ColetasPorDestinoFinal.jsx";
import MapaEstatistico from "./views/Relatorios/MapaEstatistico/MapaEstatistico.jsx";
import GeradoresSemColeta from "./views/Relatorios/GeradoresSemColeta/GeradoresSemColeta.jsx";
import InscricoesMunicipais from "./views/InscricoesMunicipais/InscricoesMunicipais.jsx";
import InscricaoMunicipaisGeradores from "./views/Relatorios/InscricaoMunicipaisGeradores/InscricaoMunicipaisGeradores.jsx";
import RedestinacoesDestino from "./views/Relatorios/RedestinacoesDestino/RedestinacoesDestino.jsx";
import CertificadoBalancaMassa from "./views/Relatorios/CertificadoBalancaMassa/CertificadoBalancaMassa.jsx";
import ResumoMovimentoMensal from "./views/Relatorios/ResumoMovimentoMensal/ResumoMovimentoMensal.jsx";
import TransportadoresRelatorio from "./views/Relatorios/Transportadores/TransportadoresRelatorio.jsx";
import TransportadoresContratosGeradores from "./views/Relatorios/TransportadoresContratosGeradores/TransportadoresContratosGeradores.jsx";
import ColetasSintetica from "./views/Relatorios/ColetasSintetica/ColetasSintetica.jsx";
import DestinosRelatorio from "./views/Relatorios/Destinos/DestinosRelatorio.jsx";
import GeradoresRelatorio from "./views/Relatorios/Geradores/GeradoresRelatorio/GeradoresRelatorio.jsx";

import PontosColetas from "./views/Mapas/PontosColetas.jsx";
import ColetasEfetuadas from "./views/Mapas/ColetasEfetuadas.jsx";
import ColetasProgramadas from "./views/Mapas/ColetasProgramadas.jsx";
import RankingDeBairros from "./views/Ranking/RankingDeBairros/RankingDeBairros.jsx";
import RankingDeDestinos from "./views/Ranking/RankingDeDestinos/RankingDeDestinos.jsx";
import RankingDeGeradores from "./views/Ranking/RankingDeGeradores/RankingDeGeradores.jsx";
import RankingDeTransportadores from "./views/Ranking/RankingDeTransportadores/RankingDeTransportadores.jsx";
import RankingDeResiduos from "./views/Ranking/RankingDeResiduos/RankingDeResiduos.jsx";
import DownloadAplicativos from "./views/DownloadAplicativos/DownloadAplicativos.jsx";
import AgendaColetas from "./views/AgendaColetas/AgendaColetas.jsx";
import Pgrss from "./views/PGRSS/Pgrss.jsx";
import FichaGerador from "./views/Cadastros/Geradores/FichaGerador.jsx";
import TransportadoresDisponiveis from "./views/TransportadoresDisponiveis/TransportadoresDisponiveis.jsx";
import GrandeGeradorSemContrato from "./views/GrandeGeradorSemContrato/GrandeGeradorSemContrato.jsx";
import Vistorias from "./views/Shared/Vistoria/Vistorias.jsx";
import MapaDeVistorias from "./views/Mapas/MapaDeVistorias.jsx";
import FormulariosDeFiscalizacao from "./views/FormulariosDeFiscalizacao/FormulariosDeFiscalizacao.jsx";
import Notificacao from "./views/Notificacao/Notificacao.jsx";
import MapaTermico from "./views/Mapas/MapaTermico.jsx";
import VistoriaGerador from "./views/VistoriaGerador/VistoriaGerador.jsx";
import VistoriaTransportador from "views/VistoriaTransportador/VistoriaTransportador.jsx";
import ManejoResiduos from "./views/ManejoResiduos/ManejoResiduos.jsx";
import ReceberResiduos from "./views/Redestinacao/ReceberResiduos/ReceberResiduos.jsx";
import EnviarResiduos from "./views/Redestinacao/EnviarResiduos/EnviarResiduos.jsx";
import GeradoresPontoColetas from "./views/Relatorios/GeradoresPontoColetas/GeradoresPontoColetas.jsx";
import GeradoresContratos from "./views/Home/components/GeradoresContratos.jsx";
import GeradoresSemPGRS from "./views/Home/components/GeradoresSemPGRS.jsx";
import PGRS from "./views/PGRS/PGRS.jsx";
import GeradoresAguardandoAtivacaoContratoPGRS from "./views/Home/components/GeradoresAguardandoAtivacaoContratoPGRS.jsx";
import GeradoresSemContratoFirmado from "views/Relatorios/GeradoresSemContratoFirmado/GeradoresSemContratoFirmado.jsx";
import GeradoresSemContratoEPendente from "views/Relatorios/GeradoresSemContratoEPendente/GeradoresSemContratoEPendente.jsx";
import CertificadoDestinacaoResiduos from "./views/Relatorios/CertificadoDestinacaoResiduos/CertificadoDestinacaoResiduos.jsx";
import AutoDeInfracao from "./views/Cadastros/AutoDeInfracao/AutoDeInfracao.jsx";
import AutoDeInfracaoImpressao from "./views/Shared/AutoDeInfracaoImpressao.jsx";
import ConsultaAutosInfracao from "./views/Consultas/ConsultaAutosInfracao.jsx";
import ConsultaDePlaca from "./views/Consultas/ConsultaDePlaca.jsx";

//importação dos icones
import {
  faChartLine,
  faPenAlt,
  faCertificate,
  faPeopleCarry,
  faDolly,
  faBalanceScale,
  faTruckLoading,
  faBell,
  faTrailer,
  faHome,
  faCogs,
  faMapMarked,
  faMailBulk,
  faHotel,
  faTruck,
  faUsers,
  faRoute,
  faFileAlt,
  faIndustry,
  faMapMarkerAlt,
  faCity,
  faTrashAlt,
  faLock,
  faUserLock,
  faSignInAlt,
  faSignOutAlt,
  faSearch,
  faMedal,
  faStoreAltSlash,
  faEnvelopeOpenText,
  faMapMarkedAlt,
  faMobileAlt,
  faKey,
  faCalendarAlt,
  faUser,
  faBoxes,
  faFileSignature,
  faEye,
  faPen,
  faUserShield,
  faSync,
  faTriangleExclamation,
  faFilePdf,
  faTags,
} from "@fortawesome/free-solid-svg-icons";

var routes = [
  {
    path: "/login",
    name: "Login",
    icon: faChartLine,
    component: Login,
    layout: "/auth",
    sidebar: false,
  },
  {
    path: "/esqueceusenha",
    name: "Esqueceu Senha",
    component: EsqueceuSenha,
    layout: "/auth",
    sidebar: false,
  },
  {
    descricao: "Cadastros - Geradores",
    path: "cadastros/geradores",
    name: "Geradores",
    icon: faIndustry,
    layout: "/auth",
    component: Geradores,
    sidebar: false,
  },
  {
    path: "/transportadoresCredenciados",
    name: "Transportadores Credenciados",
    component: TransportadoresCredenciados,
    layout: "/auth",
    sidebar: false,
  },
  {
    path: "/autoInfracaoMunicipe",
    name: "Auto de Infracao",
    layout: "/auth",
    component: AutoDeInfracaoImpressao,
    sidebar: false,
  },
  {
    path: "inicio",
    name: "Inicio",
    icon: faHome,
    component: Inicio,
    layout: "/admin",
    modulo: ["Fiscal", "Gerador", "Gestor", "Transportador", "Destino"],
    sidebar: true,
  },
  {
    path: "consulta-de-placa",
    name: "Consulta de Placa",
    modulo: ["Fiscal"],
    codigoFuncionalidade: "ConsultaPlaca",
    icon: faSearch,
    component: ConsultaDePlaca,
    layout: "/admin",
    sidebar: true,
  },
  {
    path: "dashboard",
    name: "Dashboard",
    icon: faChartLine,
    component: DashBoard,
    layout: "/admin",
    modulo: ["Fiscal", "Gestor", "Gerador", "Transportador", "Destino"],
    sidebar: true,
  },
  {
    path: "grande-gerador-sem-contrato",
    name: "Grande gerador sem contrato",
    codigoFuncionalidade: "GrandeGeradorSemContrato",
    icon: faBoxes,
    modulo: ["Fiscal", "Gestor"],
    component: GrandeGeradorSemContrato,
    layout: "/admin",
    sidebar: true,
  },
  {
    path: "vistorias",
    name: "Vistorias",
    modulo: ["Fiscal"],
    codigoFuncionalidade: "Vistorias",
    icon: faEye,
    component: Vistorias,
    layout: "/admin",
    sidebar: true,
  },
  {
    path: "formularios-de-fiscalizacao",
    name: "Formularios",
    modulo: ["Fiscal"],
    codigoFuncionalidade: "Formularios",
    icon: faFileSignature,
    component: FormulariosDeFiscalizacao,
    layout: "/admin",
    sidebar: true,
  },
  {
    path: "trocarsenha",
    name: "Trocar Senha",
    modulo: [
      "Fiscal",
      "Gerador",
      "Gestor",
      "Transportador",
      "Destino",
      "Operador",
    ],
    icon: faKey,
    component: TrocarSenha,
    layout: "/admin",
    sidebar: false,
  },
  {
    codigoFuncionalidade: "Consulta.AutosInfracao",
    path: "consulta-autos-infracoes",
    name: "Consulta Autos de Infração",
    icon: faBalanceScale,
    layout: "/admin",
    component: ConsultaAutosInfracao,
    sidebar: true,
  },
  {
    path: "notificacoes",
    name: "Notificações",
    codigoFuncionalidade: "Notificacoes",
    icon: faFileSignature,
    modulo: ["Gerador", "Transportador", "Destino"],
    component: Notificacao,
    layout: "/admin",
    sidebar: true,
  },
  {
    path: "analise-notificacoes",
    name: "Analise de Notificações",
    codigoFuncionalidade: "AnaliseNotificacao",
    icon: faSearch,
    component: Notificacao,
    modulo: ["Fiscal"],
    layout: "/admin",
    sidebar: true,
  },
  {
    name: "Cadastros",
    icon: faCogs,
    layout: "/admin",
    sidebar: true,
    prefix: "cadastros",
    modulo: ["Gestor", "Transportador"],
    submenus: [
      {
        codigoFuncionalidade: "Cadastros.AutoDeInfracao",
        descricao: "Cadastros - Auto de Infração",
        path: "cadastros/autoDeInfracao",
        name: "Auto de Infração",
        icon: faBalanceScale,
        layout: "/admin",
        modulo: ["Gestor"],
        component: AutoDeInfracao,
        sidebar: true,
      },
      {
        codigoFuncionalidade: "Cadastros.Gerador",
        descricao: "Cadastros - Geradores",
        path: "cadastros/geradores",
        name: "Geradores",
        icon: faIndustry,
        layout: "/admin",
        modulo: ["Gestor", "Transportador"],
        component: Geradores,
        sidebar: true,
      },
      {
        codigoFuncionalidade: "Cadastros.RotasColeta",
        path: "cadastros/rotas-coletas",
        name: "Rotas de Coletas",
        icon: faRoute,
        layout: "/admin",
        modulo: ["Gestor", "Transportador"],
        component: RotasColeta,
        sidebar: true,
      },
      {
        codigoFuncionalidade: "Cadastros.EscalaFuncionario",
        descricao: "Cadastros - Escala de Funcionários",
        path: "cadastros/EscalaFuncionario",
        name: "Escala de Funcionários",
        icon: faUsers,
        layout: "/admin",
        modulo: ["Gestor", "Transportador"],
        component: EscalaFuncionarios,
        sidebar: true,
      },
      {
        codigoFuncionalidade: "Cadastros.Transportador",
        descricao: "Cadastros - Transportadores",
        path: "cadastros/transportadores",
        name: "Transportadores",
        icon: faTruck,
        layout: "/admin",
        modulo: ["Gestor"],
        component: Transportadores,
        sidebar: true,
      },
      {
        codigoFuncionalidade: "Cadastros.Destinos",
        descricao: "Cadastros - Destinos",
        path: "cadastros/destinos",
        name: "Destinos",
        icon: faMapMarked,
        layout: "/admin",
        modulo: ["Gestor"],
        component: Destinos,
        sidebar: true,
      },
      {
        codigoFuncionalidade: "Cadastros.Documentos",
        descricao: "Cadastros - Documentos",
        path: "cadastros/documentos",
        name: "Documentos",
        icon: faFilePdf,
        layout: "/admin",
        modulo: ["Gestor"],
        component: Documentos,
        sidebar: true,
      },
      {
        codigoFuncionalidade: "Cadastros.Bairros",
        descricao: "Cadastros - Bairros",
        path: "cadastros/bairros",
        name: "Bairros",
        icon: faCity,
        layout: "/admin",
        modulo: ["Gestor"],
        component: Bairros,
        sidebar: true,
      },
      {
        codigoFuncionalidade: "Cadastros.Email",
        descricao: "Cadastros - Emails",
        path: "cadastros/emails",
        name: "Emails",
        icon: faMailBulk,
        layout: "/admin",
        modulo: ["Gestor"],
        component: Emails,
        sidebar: true,
      },
      {
        codigoFuncionalidade: "Cadastros.formularioPGRS",
        descricao: "Cadastros - Formulário PGRS",
        path: "cadastros/formularioPGRS",
        name: "Formulário PGRS",
        icon: faFileAlt,
        layout: "/admin",
        modulo: ["Gestor"],
        component: FormularioPGRS,
        sidebar: true,
      },
      {
        codigoFuncionalidade: "Cadastros.Prefeituras",
        descricao: "Cadastros - Prefeituras",
        path: "cadastros/prefeituras",
        name: "Prefeituras",
        icon: faHotel,
        layout: "/admin",
        modulo: ["Gestor"],
        component: Prefeituras,
        sidebar: true,
      },
      {
        codigoFuncionalidade: "Cadastros.ModalidadeColeta",
        descricao: "Cadastros - Modalidade de Coleta",
        path: "cadastros/modalidade-coleta",
        name: "Modalidade de coleta",
        icon: faTrashAlt,
        layout: "/admin",
        modulo: ["Gestor"],
        component: ModalidadeColeta,
        sidebar: true,
      },
      {
        codigoFuncionalidade: "Cadastros.TipoDestino",
        descricao: "Cadastros - Tipo de Destino",
        path: "cadastros/tipos-destino",
        name: "Tipos de destino",
        icon: faRoute,
        layout: "/admin",
        modulo: ["Gestor"],
        component: TipoDestino,
        sidebar: true,
      },
      {
        codigoFuncionalidade: "Cadastros.TipoImplemento",
        descricao: "Cadastros - Tipo de Implemento",
        path: "cadastros/tipos-implementos",
        name: "Tipos de implementos",
        icon: faTrailer,
        layout: "/admin",
        modulo: ["Gestor"],
        component: TiposImplemento,
        sidebar: true,
      },
      {
        codigoFuncionalidade: "Cadastros.TipoNotificacao",
        descricao: "Cadastros - Tipo de Notificação",
        path: "cadastros/tipos-notificacoes",
        name: "Tipos de notificações",
        icon: faBell,
        layout: "/admin",
        modulo: ["Gestor"],
        component: TipoNotificacoes,
        sidebar: true,
      },
      {
        codigoFuncionalidade: "Cadastros.Cnae",
        descricao: "Cadastros - CNAE",
        path: "cadastros/cnae",
        name: "CNAE",
        icon: faTags,
        layout: "/admin",
        modulo: ["Gestor"],
        component: Cnae,
        sidebar: true,
      },
      {
        codigoFuncionalidade: "Cadastros.TipoResiduo",
        descricao: "Cadastros - Tipo de Resíduo",
        path: "cadastros/tipos-residuos",
        name: "Tipos de residuos",
        icon: faTruckLoading,
        layout: "/admin",
        modulo: ["Gestor"],
        component: Residuos,
        sidebar: true,
      },
      {
        codigoFuncionalidade: "Cadastros.Volumetria",
        descricao: "Cadastros - Volumetria",
        path: "cadastros/volumetrias",
        name: "Volumetrias",
        icon: faBalanceScale,
        layout: "/admin",
        modulo: ["Gestor"],
        component: Volumetria,
        sidebar: true,
      },
      {
        codigoFuncionalidade: "Cadastros.ResiduoVolumetria",
        descricao: "Cadastros - Resíduos x Volumetria",
        path: "cadastros/residuo-volumetria",
        name: "Resíduo - Volumetria",
        icon: faDolly,
        layout: "/admin",
        modulo: ["Gestor"],
        component: ResiduoVolumetria,
        sidebar: true,
      },
      {
        codigoFuncionalidade: "Cadastros.RamoDeAtividade",
        descricao: "Cadastros - Ramos de Atividade",
        path: "cadastros/ramos-de-atividade",
        name: "Ramos de atividade",
        icon: faPeopleCarry,
        layout: "/admin",
        modulo: ["Gestor"],
        component: RamoDeAtividade,
        sidebar: true,
      },
      {
        codigoFuncionalidade: "Cadastros.Setores",
        descricao: "Cadastros - Setores",
        path: "cadastros/regionais",
        name: "Regionais",
        icon: faMapMarkerAlt,
        layout: "/admin",
        modulo: ["Gestor"],
        component: Regionais,
        sidebar: true,
      },
      {
        codigoFuncionalidade: "Cadastros.Certificados",
        descricao: "Cadastros - Certificados",
        path: "cadastros/certificados",
        name: "Certificados",
        icon: faCertificate,
        layout: "/admin",
        modulo: ["Gestor"],
        component: Certificados,
        sidebar: true,
      },
      {
        codigoFuncionalidade: "Cadastros.Assinaturas",
        descricao: "Cadastros - Assinaturas",
        path: "cadastros/assinaturas",
        name: "Assinaturas",
        icon: faPenAlt,
        layout: "/admin",
        modulo: ["Gestor"],
        component: Assinaturas,
        sidebar: true,
      },
    ],
  },
  {
    name: "Receber Resíduos",
    icon: faTruckLoading,
    layout: "/admin",
    modulo: ["Destino"],
    sidebar: true,
    prefix: "receber-residuos",
    submenus: [
      {
        codigoFuncionalidade: "Destinacao.Entrada",
        path: "receber-residuos/entrada",
        name: "Entrada",
        icon: faSignInAlt,
        layout: "/admin",
        modulo: ["Destino"],
        component: EntradaResiduos,
        sidebar: true,
      },
      {
        codigoFuncionalidade: "Destinacao.Saida",
        path: "receber-residuos/saida",
        name: "Saída",
        icon: faSignOutAlt,
        layout: "/admin",
        modulo: ["Destino"],
        component: SaidaResiduos,
        sidebar: true,
      },
      {
        codigoFuncionalidade: "Destinacao.ManutencaoPesagem",
        path: "receber-residuos/manutencaoPesagem",
        name: "Manutenção de Pesagem",
        icon: faSignOutAlt,
        layout: "/admin",
        modulo: ["Destino"],
        component: ManutencaoPesagem,
        sidebar: true,
      },
    ],
  },
  {
    path: "manejoResiduos",
    name: "Manejo de Resíduos",
    codigoFuncionalidade: "ManejoResíduos",
    icon: faTruck,
    component: ManejoResiduos,
    layout: "/admin",
    modulo: ["Destino"],
    sidebar: true,
  },
  {
    name: "Redestinação",
    icon: faSync,
    layout: "/admin",
    sidebar: true,
    prefix: "redestinacao",
    modulo: ["Destino"],
    submenus: [
      {
        codigoFuncionalidade: "Redestinacao.ReceberResiduos",
        path: "redestinacao/enviarResiduos",
        name: "Enviar Resíduos",
        icon: faSignOutAlt,
        layout: "/admin",
        modulo: ["Destino"],
        component: EnviarResiduos,
        sidebar: true,
      },
      {
        codigoFuncionalidade: "Redestinacao.EnviarResiduos",
        path: "redestinacao/receberResiduos",
        name: "Receber Resíduos",
        icon: faSignInAlt,
        layout: "/admin",
        modulo: ["Destino"],
        component: ReceberResiduos,
        sidebar: true,
      },
    ],
  },
  {
    name: "Coletas",
    icon: faTruckLoading,
    layout: "/admin",
    sidebar: true,
    prefix: "coletas",
    modulo: ["Gestor", "Transportador"],
    submenus: [
      {
        codigoFuncionalidade: "Coleta.OrdemColeta",
        path: "coletas/ordem-de-coleta",
        name: "Ordem de coleta",
        icon: faPeopleCarry,
        layout: "/admin",
        modulo: ["Gestor", "Transportador"],
        component: OrdemDeColeta,
        sidebar: true,
      },
      {
        codigoFuncionalidade: "Coleta.Manutencao",
        path: "coletas/manutencao-de-coletas",
        name: "Manutenção de coleta",
        icon: faTruck,
        layout: "/admin",
        modulo: ["Gestor", "Transportador"],
        component: ManutencaoColetas,
        sidebar: true,
      },
      {
        codigoFuncionalidade: "OrdemColeta.ColetasRecusadas",
        path: "coletas/coletas-recusadas",
        name: "Coletas Recusadas",
        icon: faStoreAltSlash,
        layout: "/admin",
        modulo: ["Gestor", "Transportador"],
        component: ColetasRecusadas,
        sidebar: true,
      },
    ],
  },
  {
    name: "Mapas",
    icon: faMapMarkerAlt,
    layout: "/admin",
    modulo: ["Gestor", "Transportador"],
    sidebar: true,
    prefix: "mapas",
    submenus: [
      {
        codigoFuncionalidade: "Mapas.PontosColeta",
        path: "mapas/pontos-coleta",
        name: "Pontos de coleta",
        icon: faMapMarkedAlt,
        layout: "/admin",
        modulo: ["Gestor", "Transportador"],
        component: PontosColetas,
        sidebar: true,
      },
      {
        codigoFuncionalidade: "Mapas.ColetaEfetuada",
        path: "mapas/coletas-efetuadas",
        name: "Coletas Efetuadas",
        icon: faMapMarkedAlt,
        layout: "/admin",
        modulo: ["Gestor", "Transportador"],
        component: ColetasEfetuadas,
        sidebar: true,
      },
      {
        codigoFuncionalidade: "Mapas.ColetasProgramadas",
        path: "mapas/coletas-programadas",
        name: "Coletas Programadas",
        icon: faMapMarkedAlt,
        layout: "/admin",
        modulo: ["Gestor", "Transportador"],
        component: ColetasProgramadas,
        sidebar: true,
      },
      {
        path: "mapa-de-vistorias",
        name: "Mapa de vistorias",
        codigoFuncionalidade: "MapaDeVistoria",
        icon: faMapMarkedAlt,
        modulo: ["Fiscal"],
        component: MapaDeVistorias,
        layout: "/admin",
        sidebar: true,
      },
      {
        path: "mapa-termico",
        name: "Mapa Térmico",
        codigoFuncionalidade: "MapaTermico",
        icon: faMapMarkedAlt,
        component: MapaTermico,
        modulo: ["Gerador", "Fiscal", "Gestor"],
        layout: "/admin",
        sidebar: true,
      },
    ],
  },
  {
    codigoFuncionalidade: "EmissaoDeCertificados",
    path: "emitir-certificados",
    name: "Emissão de certificados",
    icon: faCertificate,
    layout: "/admin",
    modulo: ["Gestor"],
    component: EmissaoCertificados,
    sidebar: true,
  },
  {
    codigoFuncionalidade: "cadastro.Denuncia",
    path: "denuncia",
    name: "Denúncia",
    icon: faTriangleExclamation,
    layout: "/admin",
    modulo: ["Transportador"],
    component: Denuncia,
    sidebar: true,
  },
  {
    name: "Correio Interno",
    path: "correio-interno",
    codigoFuncionalidade: "CorreioInterno",
    icon: faEnvelopeOpenText,
    layout: "/admin",
    component: CorreioInterno,
    sidebar: true,
    modulo: ["Gestor"],
  },
  {
    name: "Mensagem Internoa",
    path: "mensagem-interna",
    codigoFuncionalidade: "",
    icon: faEnvelopeOpenText,
    layout: "/admin",
    modulo: ["Gestor", "Transportador", "Destino", "Gerador"],
    component: MensagemInterna,
    sidebar: false,
  },
  {
    name: "Pesquisa MTR",
    path: "pesquisa-{identificacaoDocumentoColeta}",
    codigoFuncionalidade: "OrdemColeta.PesquisaMTR",
    icon: faSearch,
    layout: "/admin",
    component: PesquisaMTR,
    modulo: ["Gestor", "Transportador", "Destino", "Gerador"],
    sidebar: true,
  },
  {
    name: "Inscrição Imobiliária",
    path: "inscricoesImobiliaria",
    modulo: ["Gerador", "Gestor"],
    icon: faPen,
    layout: "/admin",
    component: InscricoesMunicipais,
    sidebar: true,
  },
  {
    name: "Pesquisa não coleta",
    path: "pesquisa-nao-coleta",
    codigoFuncionalidade: "OrdemColeta.PesquisaNaoColeta",
    icon: faSearch,
    layout: "/admin",
    modulo: ["Transportador"],
    component: PesquisaNaoColeta,
    sidebar: true,
  },
  {
    codigoFuncionalidade: "TransportadoresDisponiveis",
    descricao: "Transportadores Disponiveis",
    path: "transportadores-disponiveis",
    name: "Transportadores disponiveis",
    icon: faTruck,
    layout: "/admin",
    modulo: ["Gerador"],
    component: TransportadoresDisponiveis,
    sidebar: true,
  },
  {
    codigoFuncionalidade: "AgendaColetas",
    path: "agenda-de-coletas",
    modulo: ["Gerador"],
    name: "Agenda de coletas",
    icon: faCalendarAlt,
    layout: "/admin",
    component: AgendaColetas,
    sidebar: true,
  },
  {
    path: "relatorio/relatorioMTR",
    name: "Relatorios",
    icon: faMedal,
    layout: "/empty",
    component: RelatorioMTR,
    sidebar: false,
  },
  {
    path: "relatorio/relatorioCTR-RGG",
    name: "Relatorios",
    icon: faMedal,
    layout: "/empty",
    component: RelatorioMTR,
    sidebar: false,
  },
  {
    path: "relatorio/EmitirCertificado",
    name: "Relatorios",
    icon: faMedal,
    layout: "/empty",
    component: CertificadoEmitido,
    sidebar: false,
  },
  {
    codigoFuncionalidade: "Relatorios",
    path: "relatorios",
    name: "Relatórios",
    icon: faFileAlt,
    layout: "/admin",
    layoutRelatorio: true,
    component: Relatorios,
    modulo: ["Gestor", "Destino", "Gerador", "Transportador"],
    sidebar: true,
  },
  {
    codigoFuncionalidade: "Relatorios.DetalhadoGerador",
    path: "relatorios/DetalhadoGerador",
    name: "Relatórios",
    icon: faFileAlt,
    layout: "/admin",
    component: DetalhadoPorGerador,
    sidebar: false,
  },
  {
    codigoFuncionalidade: "Relatorios.DetalhadoTransportador",
    path: "relatorios/DetalhadoTransportador",
    name: "Relatórios",
    icon: faFileAlt,
    layout: "/admin",
    component: DetalhadoPorTransportador,
    sidebar: false,
  },
  {
    codigoFuncionalidade: "Relatorios.Redestinacoes",
    path: "relatorios/Redestinacoes",
    name: "Relatórios",
    icon: faFileAlt,
    layout: "/admin",
    component: RedestinacoesDestino,
    sidebar: false,
  },
  {
    codigoFuncionalidade: "Relatorios.transportadores",
    path: "relatorios/transportadores",
    name: "Relatórios",
    icon: faFileAlt,
    layout: "/admin",
    component: TransportadoresRelatorio,
    sidebar: false,
  },
  {
    codigoFuncionalidade: "Relatorios.Destinos",
    path: "relatorios/destinos",
    name: "Relatórios",
    icon: faFileAlt,
    layout: "/admin",
    component: DestinosRelatorio,
    sidebar: false,
  },
  {
    codigoFuncionalidade: "Relatorios.CertificadoBalancaMassa",
    path: "relatorios/CertificadoBalancaMassa",
    name: "Relatórios",
    icon: faFileAlt,
    layout: "/admin",
    component: CertificadoBalancaMassa,
    sidebar: false,
  },
  {
    codigoFuncionalidade: "Relatorios.ResumoMovimentoMensal",
    path: "relatorios/ResumoMovimentoMensal",
    name: "Relatórios",
    icon: faFileAlt,
    layout: "/admin",
    component: ResumoMovimentoMensal,
    sidebar: false,
  },
  {
    codigoFuncionalidade: "Relatorios.ColetasTransportador",
    path: "relatorios/ColetasTransportador",
    name: "Relatórios",
    icon: faFileAlt,
    layout: "/admin",
    component: ColetasPorTransportador,
    sidebar: false,
  },
  {
    codigoFuncionalidade: "Relatorios.ColetasDetalhado",
    path: "relatorios/ColetasDetalhado",
    name: "Relatórios - Coletas Detalhado",
    modulo: ["Gerador", "Transportador"],
    icon: faFileAlt,
    layout: "/admin",
    component: ColetasDetalhado,
    sidebar: false,
  },
  {
    path: "vistoriasGerador",
    name: "Vistorias",
    modulo: ["Gerador"],
    icon: faEye,
    component: VistoriaGerador,
    layout: "/admin",
    sidebar: true,
  },
  {
    path: "vistoriasTransportador",
    name: "Vistorias",
    modulo: ["Transportador"],
    icon: faEye,
    component: VistoriaTransportador,
    layout: "/admin",
    sidebar: true,
  },
  {
    codigoFuncionalidade: "Relatorios.ColetasResumido",
    path: "relatorios/ColetasResumido",
    name: "Relatórios",
    icon: faFileAlt,
    layout: "/admin",
    component: ColetasResumido,
    sidebar: false,
  },
  {
    codigoFuncionalidade: "Relatorios.DemonstrativoDeResumoDeOperacoes",
    path: "relatorios/DemonstrativoDeResumoDeOperacoes",
    name: "Relatórios",
    icon: faFileAlt,
    layout: "/admin",
    component: DemonstrativoDeResumoDeOperacoes,
    sidebar: false,
  },
  {
    codigoFuncionalidade: "Relatorios.DesmonstrativoDeColetasPorGerador",
    path: "relatorios/DesmonstrativoDeColetasPorGerador",
    name: "Relatórios",
    icon: faFileAlt,
    layout: "/admin",
    component: DemonstrativoDeColetasPorGeradores,
    sidebar: false,
  },
  {
    codigoFuncionalidade: "Relatorios.ContratosTransportador",
    path: "relatorios/ContratosPorTransportador",
    name: "Relatórios",
    icon: faFileAlt,
    layout: "/admin",
    component: ContratosPorTransportador,
    sidebar: false,
  },
  {
    codigoFuncionalidade: "Relatorios.EntradasAvulsas",
    path: "relatorios/EntradasAvulsas",
    name: "Relatórios",
    icon: faFileAlt,
    layout: "/admin",
    component: EntradasAvulsas,
    sidebar: false,
  },
  {
    codigoFuncionalidade: "Relatorios.ColetasGerador",
    path: "relatorios/ColetasGerador",
    name: "Relatórios",
    icon: faFileAlt,
    layout: "/admin",
    component: ColetasPorGerador,
    sidebar: false,
  },
  {
    codigoFuncionalidade: "Relatorios.GeradoresSemColeta",
    path: "relatorios/GeradoresSemColeta",
    name: "Relatórios",
    icon: faFileAlt,
    layout: "/admin",
    component: GeradoresSemColeta,
    sidebar: false,
  },
  {
    codigoFuncionalidade: "Relatorios.InscricaoMunicipaisGeradores",
    path: "relatorios/InscricaoMunicipaisGeradores",
    name: "Relatórios",
    icon: faFileAlt,
    layout: "/admin",
    component: InscricaoMunicipaisGeradores,
    sidebar: false,
  },
  {
    codigoFuncionalidade: "Relatorios.ColetasDestino",
    path: "relatorios/ColetasDestino",
    name: "Relatórios",
    icon: faFileAlt,
    layout: "/admin",
    component: ColetasPorDestinoFinal,
    sidebar: false,
  },
  {
    codigoFuncionalidade: "Relatorios.MapaEstatistico",
    path: "relatorios/MapaEstatistico",
    name: "Relatórios",
    icon: faFileAlt,
    layout: "/admin",
    component: MapaEstatistico,
    sidebar: false,
  },
  {
    codigoFuncionalidade: "Relatorios.RankingBairro",
    path: "relatorios/ranking-de-bairros",
    name: "Relatorios",
    icon: faMedal,
    layout: "/admin",
    component: RankingDeBairros,
    sidebar: false,
  },
  {
    codigoFuncionalidade: "Relatorios.RankingDestino",
    path: "relatorios/ranking-de-destinos",
    name: "Relatorios",
    icon: faMedal,
    layout: "/admin",
    component: RankingDeDestinos,
    sidebar: false,
  },
  {
    codigoFuncionalidade: "Relatorios.RankingGerador",
    path: "relatorios/ranking-de-geradores",
    name: "Relatorios",
    icon: faMedal,
    layout: "/admin",
    component: RankingDeGeradores,
    sidebar: false,
  },
  {
    codigoFuncionalidade: "Relatorios.RankingTransportador",
    path: "relatorios/ranking-de-transportadores",
    name: "Relatorios",
    icon: faMedal,
    layout: "/admin",
    component: RankingDeTransportadores,
    sidebar: false,
  },
  {
    codigoFuncionalidade: "Relatorios.RankingResiduo",
    path: "relatorios/ranking-de-residuos",
    name: "Relatorios",
    icon: faMedal,
    layout: "/admin",
    component: RankingDeResiduos,
    sidebar: false,
  },
  {
    codigoFuncionalidade: "Relatorios.transportadoresContratos",
    path: "relatorios/TransportadoresContratosGeradores",
    name: "Relatorios",
    icon: faMedal,
    layout: "/admin",
    component: TransportadoresContratosGeradores,
    sidebar: false,
  },
  {
    codigoFuncionalidade: "Relatorios.ColetaSintetica",
    path: "relatorios/ColetaSintetica",
    name: "Relatorios",
    icon: faMedal,
    layout: "/admin",
    component: ColetasSintetica,
    sidebar: false,
  },
  {
    codigoFuncionalidade: "Relatorios.GeradoresPontoColetas",
    path: "relatorios/GeradoresPontoColetas",
    name: "Relatorios",
    icon: faMedal,
    layout: "/admin",
    component: GeradoresPontoColetas,
    sidebar: false,
  },
  {
    codigoFuncionalidade: "Relatorios.GeradoresSemContratoFirmado",
    path: "relatorios/GeradoresSemContratoFirmado",
    name: "Relatorios",
    icon: faFileAlt,
    layout: "/admin",
    component: GeradoresSemContratoFirmado,
    sidebar: false,
  },
  {
    codigoFuncionalidade: "Relatorios.GeradoresSemContratoEPendente",
    path: "relatorios/GeradoresSemContratoEPendente",
    name: "Relatorios",
    icon: faFileAlt,
    layout: "/admin",
    component: GeradoresSemContratoEPendente,
    sidebar: false,
  },
  {
    codigoFuncionalidade: "Relatorios.CertificadoDestinacaoResiduos",
    path: "relatorios/CertificadoDestinacaoResiduos",
    name: "Relatórios - Certificado de destinação de resíduos",
    icon: faFileAlt,
    layout: "/admin",
    component: CertificadoDestinacaoResiduos,
    sidebar: false,
  },
  {
    codigoFuncionalidade: "Relatorios.Geradores",
    path: "relatorios/Geradores",
    name: "Relatórios - Geradores",
    icon: faFileAlt,
    layout: "/admin",
    component: GeradoresRelatorio,
    sidebar: false,
  },
  {
    codigoFuncionalidade: "PGRSS",
    path: "pgrss",
    name: "PGRSS",
    icon: faFileAlt,
    layout: "/admin",
    component: Pgrss,
    sidebar: true,
  },
  {
    codigoFuncionalidade: "PGRS",
    path: "pgrs",
    name: "PGRS",
    icon: faFileAlt,
    layout: "/admin",
    component: PGRS,
    sidebar: true,
  },
  {
    name: "Segurança",
    icon: faLock,
    layout: "/admin",
    sidebar: true,
    prefix: "seguranca",
    modulo: ["Gestor"],
    submenus: [
      {
        codigoFuncionalidade: "Seguranca.Usuarios",
        descricao: "Segurança - Usuários",
        path: "seguranca/usuarios",
        name: "Usuários",
        icon: faUserLock,
        layout: "/admin",
        component: Usuarios,
        sidebar: true,
      },
      {
        codigoFuncionalidade: "Seguranca.Integracao",
        descricao: "Usuários de Integração",
        path: "seguranca/usuariosIntegracao",
        name: "Usuários Integração",
        icon: faUserShield,
        layout: "/admin",
        component: UsuarioExternos,
        sidebar: true,
      },
    ],
  },
  {
    path: "download-aplicativos",
    name: "Download Aplicativos",
    icon: faMobileAlt,
    layout: "/admin",
    modulo: ["Transportador", "Gestor", "Fiscal"],
    component: DownloadAplicativos,
    sidebar: true,
  },
  {
    codigoFuncionalidade: "Cadastros.MeuCadastro",
    path: "meuCadastro",
    name: "Meu Cadastro",
    icon: faUser,
    layout: "/admin",
    component: FichaTransportador,
    sidebar: true,
  },
  {
    codigoFuncionalidade: "Cadastros.MeuCadastroGerador",
    path: "meu-cadastro",
    name: "Meu Cadastro",
    icon: faUser,
    layout: "/admin",
    modulo: ["Gerador"],
    component: FichaGerador,
    sidebar: true,
  },
  {
    path: "geradores/contratos",
    name: "Geradores Contratos",
    icon: faFileAlt,
    layout: "/admin",
    component: GeradoresContratos,
    modulo: ["Gestor", "Gerador", "Transportador"],
    sidebar: false,
  },
  {
    path: "geradoresSemPGRS",
    name: "Geradores Sem PGRS",
    icon: faFileAlt,
    layout: "/admin",
    component: GeradoresSemPGRS,
    modulo: ["Gestor"],
    sidebar: false,
  },
  {
    path: "geradores/aguardandoAtivacaoContratoPGRS",
    name: "Geradores Aguardando Ativação de Contrato",
    icon: faFileAlt,
    layout: "/admin",
    component: GeradoresAguardandoAtivacaoContratoPGRS,
    modulo: ["Gestor", "Gerador", "Transportador"],
    sidebar: false,
  },
];
export default routes;
